import { render } from "./SpaceAddEditTagListComponent.vue?vue&type=template&id=889aec30&scoped=true&ts=true"
import script from "./SpaceAddEditTagListComponent.vue?vue&type=script&lang=ts"
export * from "./SpaceAddEditTagListComponent.vue?vue&type=script&lang=ts"

import "./SpaceAddEditTagListComponent.vue?vue&type=style&index=0&id=889aec30&lang=scss"
import "./SpaceAddEditTagListComponent.vue?vue&type=style&index=1&id=889aec30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889aec30"]])

export default __exports__